import provideDataHook from '~/helpers/provideDataHook';
import {
  CarBrandAndCategory,
  getDataHook
} from '~/App/views/CarTreeAndCategory/CarBrandAndCategory';

export default provideDataHook(
  'CarCategory',
  getDataHook({ mainCategory: 'car' })
)(CarBrandAndCategory);
